<aslib-title Text="Sistemas" SubText="Sefaz SARF" Icon="fa fa-home"></aslib-title>
<div class="row justify-content-center align-items-center">SARF - Sistema de Administração de Recursos Financeiros</div>



// WEBPACK FOOTER //
// ./src/app/pagina-inicial/pagina-inicial.component.html